export default __webpack_public_path__ + "static/IBMPlexSans-TextItalic-Cyrillic-8215d4d6ec6134ba573d0a4d56333606.woff";